import axios from "axios";

// Creating an instance for axios to be used by the token interceptor service
const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND_HOST}`,
});

export default axiosInstance;